require('intersection-observer')
import lozad from 'lozad'
let axios = require('axios')
import { tns } from 'tiny-slider/src/tiny-slider.module'
import TweenLite from 'gsap/TweenLite'
import 'gsap/ScrollToPlugin'
import Power2 from 'gsap/EasePack'

// states
var cancel
var prevNavigation = null
var currNavigation = null

// elements
var body
var main
var header
var navigationElements
var news
var posts
var sliderContainer
var categories
var categoryHeadline

// calculations
var documentHeight
var windowHeight
var targetScrollTopOffset
var targetScrollTopOffsetToScroll
var categoryHeadlineHeight

// function scrollIt
var scrollStart = window.pageYOffset || 0
var scrollStartTime = 'now' in window.performance ? performance.now() : new Date().getTime()
var raf

// function setSlider
var sliderOptions = {
  container: '#slider',
  items: 1,
  gutter: 6,
  loop: true,
  nested: "inner",
  controls: false,
  nav: false,
  autoplay: true,
  touch: false,
  autoplayButtonOutput: false,
  responsive: {
    480: {
      items: 2
    },
    960: {
      items: 3
    },
    1200: {
      items: 4
    }
  }
}

if (window.Element) {
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector
  }
  
  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i,
          el = this
      do {
          i = matches.length
          while (--i >= 0 && matches.item(i) !== el) {}
      } while ((i < 0) && (el = el.parentElement))
      return el
    }
  }
}

function debounce(func, wait, immediate) {

    var timeout;

    return function() {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        }, wait);
        if (immediate && !timeout) func.apply(context, args);
    };

};

function getOffset (el) {
  el = el.getBoundingClientRect()
  return {
    left: el.left + window.scrollX,
    top: el.top + window.scrollY
  }
}

function getElements () {
  body = document.body
  main = body.querySelector('#main')
  header = body.querySelector('#header')
  navigationElements = body.querySelectorAll('a.scroll')
  news = header.querySelector('#news')
  posts = news.querySelectorAll('.post')
  sliderContainer = news.querySelector('#header-images')
  categories = main.querySelectorAll('.category')
  categoryHeadline = main.querySelector('.category-headline')
}

function getElementsAttributes () {
  documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight)
  windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight
  categoryHeadlineHeight = categoryHeadline.offsetHeight
}

function getActiveCategory () {
  var getActiveCategory = main.querySelector('.category.active')
  if (getActiveCategory) {
    currNavigation = getActiveCategory.id
  }
}

var CancelToken = axios.CancelToken
var requestHref = axios.create({
  transformResponse: [function (data) {
    return data
  }],
  responseType: 'document'
})

function getHref (href) {
  requestHref.get(href, {
    cancelToken: new CancelToken(function executor (c) {
      // An executor function receives a cancel function as a parameter
      cancel = c
    })
  }).then(function (response) {
    cancel()
    var getActiveCategory = main.querySelector('.category.active')
    var getActiveCategoryLinks = getActiveCategory.querySelectorAll('.project-image-link')
    var getResponseMain = response.request.responseXML.querySelector('#main')
    var getResponseActiveCategory = getResponseMain.querySelector('.category.active')
    var getResponseActiveImages = getResponseActiveCategory.querySelectorAll('.imageset.active')
    for (var i = 0; i < getActiveCategoryLinks.length; i++) {
      getActiveCategoryLinks[i].appendChild(getResponseActiveImages[i])
    }
    getActiveCategory.classList.remove('lazy-ajax')
    //  var getMainHtml = getMain.innerHTML

    //  main.innerHTML = getMainHtml
  }).catch(function (thrown) {
    if (axios.isCancel(thrown)) {
      console.log('Request canceled', thrown.message)
    } else {
      var baseUrl = window.location.origin
      var errorUrl = baseUrl + '/error'
    }
  })
}

function setHref (id, href) {
  getHref(href)
}

function scrollToTarget (target) {
  console.log('fired')
  var delay = prevNavigation !== currNavigation ? .5 : 0
  var targetElement = document.querySelector(target)
  var padding = targetElement.querySelector('.ajax') ? -categoryHeadlineHeight : 0;
  var targetScrollTop = getOffset(targetElement).top
  var currentScrollTop = window.scrollY || window.scrollTop || document.getElementsByTagName('html')[0].scrollTop || 0
  var distance = Math.abs(parseInt(targetScrollTop) - parseInt(currentScrollTop))
  var time = distance === 0 ? 0 : Math.min(Math.max(.25, (distance / 1000)), .9)
  //  if (distance !== 0) {
    TweenLite.to(window, time, {scrollTo:{y: targetScrollTop + padding}, delay: delay, ease:Power2.easeInOut});
  //  }
}

function navigationElementListener (e) {
  var target = e.target
  if (target.parentElement.parentElement.matches('.ajax')) {
    target = target.parentElement.parentElement
  }
  if (target.matches('.scroll')) {
    e.preventDefault()

    prevNavigation = currNavigation
    // var currTarget = main.classList
    var id = target.getAttribute('data-target')
    var href = target.getAttribute('href')
    if (target.matches('.ajax')) {
      if (!main.matches('.active')) {
        main.classList.add('active')
      }
      var href = target.getAttribute('href') // target.href
      var parentCategory = target.closest('.category')
      if (!parentCategory.matches('.active')) {
        for (var i = 0; i < categories.length; i++) {
          categories[i].classList.remove('active')
        }
        currNavigation = parentCategory.id
        parentCategory.classList.add('active')
        if (parentCategory.matches('.lazy-ajax')) {
          setHref(id, href)
        }
      }
    }
    scrollToTarget(id)
    var state = {id: id, currNavigation: currNavigation}
    history.pushState(state, null, href)
    console.log('prevNavigation: ' + prevNavigation)
    console.log('currNavigation: ' + currNavigation)
  }
}

var resizeListener = debounce(function() {
    getElementsAttributes()
}, 200);

function popstateListener (e) {
  var state = e.state
  if (state) {
    var id = state.id
    var stateNavigation = state.currNavigation

    if (currNavigation) {
      main.querySelector('#' + currNavigation).classList.remove('active')
    }
    if (stateNavigation) {
      main.querySelector('#' + stateNavigation).classList.add('active')
    } else {
      console.log('it’s true');
      main.classList.remove('active')
    }
    prevNavigation = currNavigation
    currNavigation = stateNavigation
    var targetElement = document.querySelector(id)
    var padding = targetElement.querySelector('.ajax') ? -categoryHeadlineHeight : 0;
    var targetScrollTop = getOffset(targetElement).top
    TweenLite.set(window, {scrollTo:{y: targetScrollTop + padding}});
  //  console.log('test')
  //  scrollToTarget(id)
  //  if (currNavigation !== null) {
  //    if (!main.matches('.active')) {
  //      main.classList.add('active')
  //      if (currNavigation !== prevNavigation) {
  //        setTimeout(function () {
  //          scrollToTarget(id)
  //        }, 500)
  //      }  else {
  //        scrollToTarget(id)
  //      }
  //    }
  //  } else {
  //      main.classList.remove('active')
  //        scrollToTarget(id)
  //  }
  }
}

function setEventListeners () {
  window.addEventListener('resize', resizeListener);
  window.addEventListener('popstate', popstateListener)
  body.addEventListener('click', navigationElementListener)
}

function setSlider () {
  tns(sliderOptions);
}

function init () {
  getElements()
  setTimeout(getElementsAttributes, 20)
  setTimeout(getActiveCategory, 25)
  setTimeout(setEventListeners, 30)
  setTimeout(setSlider, 35)

}

init()